<template>
  <div class="container">
    <div class="d-flex flex-row justify-content-center tophead header-navbar pt-5px pb-5px">
      <div class="slogan d-none d-md-block">
        <div class="name text-white font-size36-be-vietnam font-weight-800 font-Montserrat ">
          CỔNG TIN TỨC ĐÀI TIẾNG NÓI VIỆT NAM
        </div>
        <div class="sologan text-center font-Inter font-size24-be-vietnam">
          Tốc độ - Trí tuệ - Tầm vóc
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { $themeConfig } from '@themeConfig'
import {
  BLink, BImg, BNavbarNav, VBToggle, BDropdownItem,
} from 'bootstrap-vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue';
import NotificationDropdown from '@core/layouts/components/app-navbar/components/NotificationDropdown.vue';

export default {
  components: {
    BLink,
    BImg,
    BNavbarNav,
    Locale,
    NotificationDropdown,
    BDropdownItem,
  },
  directives: {
    'b-toggle': VBToggle,
  },

  setup(props) {
    const { appName, appLogoImage } = $themeConfig.app

    return {
      appName,
      appLogoImage,
    }
  },
}
</script>
